import React from 'react';
import './InFlightTable.css';

const InFlightTable = ({ flightData, onRowClick }) => {
    if (!flightData || flightData.length === 0) {
        return (
            <div className="inflight-table-container">
                <div className="no-flights-message">
                    <p>No flights currently in progress</p>
                </div>
            </div>
        );
    }

    return (
        <div className="inflight-table-container">
            <table className="inflight-table">
                <thead>
                    <tr>
                        <th>USER</th>
                        <th className="left">EQPT</th>
                        <th>ORIG</th>
                        <th>DEST</th>
                        <th>SPD</th>
                        <th>ALT</th>
                        {/* <th>HDG</th> */}
                        <th>NM</th>
                        <th>DTG</th>
                        <th>TTG</th>
                        <th>ETA UTC</th>
                    </tr>
                </thead>
                <tbody>
                    {flightData.map((flight, index) => (
                        <tr 
                            key={flight.id} 
                            onClick={() => onRowClick && onRowClick(index, flight)}
                            className="clickable-row"
                        >
                            <td className="user-cell">{flight.user}</td>
                            <td className="eqpt" >{flight.eqpt}</td>
                            <td>{flight.orig}</td>
                            <td>{flight.dest}</td>
                            <td>{flight.spd}</td>
                            <td>{flight.alt}</td>
                            {/* <td>{flight.hdg}°</td> */}
                            <td>{flight.dtr}</td>
                            <td>{flight.dtg}</td>
                            <td>{flight.ttg}</td>
                            <td>{flight.eta === 'Arrived' ? '...' : flight.eta}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default InFlightTable;
